export default function InfoCard({ icon: Icon, title, text, bullets, accent }) {
  const iconClass = `info-card__icon ${accent === 'orange' ? 'info-card__icon--orange' : ''}`.trim();

  return (
    <article className="info-card">
      {Icon ? (
        <div className={iconClass}>
          <Icon size={22} />
        </div>
      ) : null}
      <h3>{title}</h3>
      {text ? <p>{text}</p> : null}
      {bullets ? (
        <ul className="check-list">
          {bullets.map((bullet) => (
            <li key={bullet}>{bullet}</li>
          ))}
        </ul>
      ) : null}
    </article>
  );
}
